//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// We can probably remove this import but I'm afraid of breaking anything right now
// eslint-disable-next-line
import { required } from 'vuelidate/lib/validators';
import isDate from '../../../../../lib/validators/isDate';
import ValidationMixin from '../../../../common/form/mixins/ValidationMixin';

export default {
  name: 'MemberBirthDate',
  mixins: [ValidationMixin],
  props: {
    value: {
      type: String,
      default: null,
    },
    updating: {
      type: Boolean,
      default: false,
    },
  },
  data: function data() {
    return {
      monthOptions: [
        { value: '', text: 'Month' },
        { value: '01', text: 'January' },
        { value: '02', text: 'February' },
        { value: '03', text: 'March' },
        { value: '04', text: 'April' },
        { value: '05', text: 'May' },
        { value: '06', text: 'June' },
        { value: '07', text: 'July' },
        { value: '08', text: 'August' },
        { value: '09', text: 'September' },
        { value: '10', text: 'October' },
        { value: '11', text: 'November' },
        { value: '12', text: 'December' },
      ],
      dayCounts: {
        '01': 31, '02': 29, '03': 31, '04': 30, '05': 31, '06': 30, '07': 31, '08': 31, '09': 30, 10: 31, 11: 30, 12: 31,
      },
    };
  },
  computed: {
    month() {
      if (this.value === null) {
        return '';
      }
      return this.value.split('-')[1];
    },
    day() {
      if (this.value === null) {
        return '';
      }
      if (this.month === null || this.month === '') {
        return '';
      }
      return this.value.split('-')[2];
    },
    year() {
      if (this.value === null) {
        return '';
      }
      return this.value.split('-')[0];
    },
    birthDate() {
      const year = this.$refs.year.value;
      const month = this.$refs.month.value;
      const day = this.$refs.day.value;
      return this.buildDate(month, day, year);
    },
    dayOptions() {
      const pad = '00';
      const ret = [{ value: '', text: 'Day' }];
      for (let i = 1; i <= this.dayCounts[this.month]; i += 1) {
        ret.push({
          value: pad.substring(0, pad.length - i.toString().length) + i.toString(),
          text: i,
        });
      }
      return ret;
    },
    yearOptions() {
      const ret = [{ value: '', text: 'Year' }];
      const year = (new Date()).getFullYear();
      for (let i = (year - 100); i <= year; i += 1) {
        ret.push({ value: i.toString(), text: i.toString() });
      }
      return ret;
    },
  },
  validations: {
    value: {
      isDate,
    },
  },
  methods: {
    onMonth(month) {
      this.$emit('input', this.buildDate(month, this.$refs.day.value, this.$refs.year.value));
    },
    onDay(day) {
      this.$emit('input', this.buildDate(this.$refs.month.value, day, this.$refs.year.value));
    },
    onYear(year) {
      this.$emit('input', this.buildDate(this.$refs.month.value, this.$refs.day.value, year));
    },
    getErrors() {
      const errors = [];
      if (!this.$v.value.validDate) {
        errors.push('Birth Date is required');
      }
      return errors;
    },
    buildDate(month, day, year) {
      return `${year}-${month}-${day}`;
    },
  },
};
